// Note: Cookie Type values should be in lower case as they are used to compose cookie value.
export enum CookieType {
  FUNCTIONAL = "functional",
  PERFORMANCE = "performance",
  ADVERTISING = "advertising"
}
